import React from 'react';

import DomainTable from './domainTable.js'
import {TechnologyDomains} from '../../../server/routes/route-types.js'

export default function DomainTablePage({domainList}: {domainList: TechnologyDomains}) {

	return (
		<>
            <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <DomainTable domainList={domainList}/>
                        </div>
                    </div>
                </div>
            </section>
		</>
	)
}
